const PREFIX = 'ccrm:list:';

const emptyState = () => ({ search: '', filters: {}, page: 1 });

export function readTableState(key) {
    try {
        const raw = window.localStorage.getItem(PREFIX + key);
        if (!raw) return emptyState();
        const parsed = JSON.parse(raw);
        return {
            search: typeof parsed.search === 'string' ? parsed.search : '',
            filters: parsed.filters && typeof parsed.filters === 'object' ? parsed.filters : {},
            page: Number(parsed.page) > 0 ? Number(parsed.page) : 1,
        };
    } catch (e) {
        return emptyState();
    }
}

export function writeTableState(key, state) {
    try {
        window.localStorage.setItem(PREFIX + key, JSON.stringify(state));
    } catch (e) {
        // Storage indisponível: a lista funciona sem persistir.
    }
}
